import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomLoaderService {

  constructor() { }

  btnStartLoading(button_id: string, btn = null) {
    // get the button
    let button = btn;

    if (!button)
      button = document.getElementById(button_id) as HTMLButtonElement;

    button.disabled = true;
    button.classList.add('mat-button-disabled');

    const childElement = document.createElement("div");
    childElement.setAttribute("id", "btn-loader");
    button.appendChild(childElement);

    let loader = button.querySelector("#btn-loader");
    loader.classList.add('custom-loader');
  }

  btnStopLoading(button_id: string, btn = null) {
    // get the button
    let button = btn;

    if (!button)
      button = document.getElementById(button_id) as HTMLButtonElement;

    button.disabled = false;
    button.classList.remove('mat-button-disabled');


    let loader = button.querySelector("#btn-loader");
    if (loader)
      loader.classList.remove('custom-loader');
  }

  containerStartLoading(event, container_selector) {
    (event.target).closest(container_selector).querySelector('.container-loader').classList.remove('hidden');
  }
  containerStopLoading(event, container_selector) {
    (event.target).closest(container_selector).querySelector('.container-loader').classList.add('hidden');
  }

}
